// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5b2147ee","453":"73642bc4","849":"ed2f6d27","977":"cd41ab8f"}[chunkId] + ".chunk.js";
};